import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-8 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-171">
      <FadeIn data-id="element-172">
        <div className="bg-[#020617] border border-[#22c55e]/30 rounded-2xl md:rounded-[2.5rem] p-5 md:p-16 text-center relative overflow-hidden shadow-[0_20px_50px_rgba(2,6,23,0.15)]" data-id="element-173">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#22c55e_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-174"></div>

          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-transparent via-[#22c55e] to-transparent" data-id="element-175"></div>

          <div className="relative z-10" data-id="element-176">
            <div className="inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#22c55e]/10 mb-4 md:mb-8 border-2 border-[#22c55e]/20 relative" data-id="element-177">
              <div className="absolute inset-0 bg-[#22c55e]/20 blur-2xl rounded-full animate-pulse" data-id="element-178"></div>
              <ShieldCheck className="w-10 h-10 md:w-14 md:h-14 text-[#22c55e] relative z-10" data-id="element-179" />
              <div className="absolute -bottom-2 -right-2 bg-[#22c55e] text-black rounded-full p-1.5 md:p-2 shadow-lg" data-id="element-180">
                <Award className="w-4 h-4 md:w-5 md:h-5" data-id="element-181" />
              </div>
            </div>

            <h2 className="text-2xl md:text-5xl font-black mb-4 md:mb-8 text-white tracking-tight" data-id="element-182">
              GARANTÍA 7 DÍAS <br className="md:hidden" data-id="element-183" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#22c55e] to-[#4ade80]" data-id="element-184">
                — SIN PREGUNTAS
              </span>
            </h2>

            <div className="space-y-3 md:space-y-6 text-base md:text-2xl text-[#e2e8f0] font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-185">
              <p data-id="element-186">
                Abrís los tomos. Los aplicás 7 días. Si no es exactamente lo que
                esperabas:
              </p>
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-[#22c55e]/10 border border-[#22c55e]/30 rounded-2xl p-4 md:p-6 mt-4 md:mt-8 inline-block" data-id="element-187">
                <p className="text-[#22c55e] font-black text-lg md:text-3xl" data-id="element-188">
                  → Devolución del 100%. <br className="md:hidden" data-id="element-189" />
                  Sin formularios. Sin drama.
                </p>
              </motion.div>
              <p className="text-xs md:text-sm text-[#475569] mt-5 md:mt-10 pt-4 md:pt-8 border-t border-[#22c55e]/20 uppercase tracking-widest font-bold" data-id="element-190">
                Tasa de devolución: menos del 1%.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}